// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const focusMapper = function (this: any, key: string, value: any) {
    if (key.includes('-')) {
        const newKey = key.replace(/-([a-z])/g, (_match, group1) => group1.toUpperCase());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this[newKey] = value;
    } else {
        return value;
    }
};
